import { ref, readonly } from 'vue'

export const useBusinessTypes = (initial, master) => {
  const state = ref(structuredClone(initial))

  const set = (value) => {
    state.value = value.sort((a, b) => a - b)
  }

  const reset = () => {
    state.value = structuredClone(initial)
  }

  const clear = () => {
    state.value = []
  }

  // 選択された業種テキスト(カンマ区切り)
  const getText = () => {
    let codeText = []
    state.value.some(code => {
      let index = master.findIndex(conditionType => code == conditionType.code)
      if(index !== -1) {
        codeText[index] = master[index].text
      }
    })
    /* NOTE: 業種はソートするキーを持っていない
     * 同じ要素番号に格納して、値が入っていない要素を削除している
     */
    codeText = codeText.filter(Boolean)
    return codeText.join(',')
  }

  return { businessTypes: readonly(state), master: readonly(master), set, reset, clear, getText }
}